{
    "choiceSetInputValueSeparator": ",",
    "supportsInteractivity": true,
    "spacing": {
        "small": 8,
        "default": 12,
        "medium": 16,
        "large": 20,
        "extraLarge": 24,
        "padding": 16
    },
    "separator": {
        "lineThickness": 1,
        "lineColor": "#525252"
    },
    "fontTypes": {
        "default": {
            "fontFamily": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Selawik, system-ui, 'Apple Color Emoji', 'Segoe UI Emoji', 'Noto Color Emoji', sans-serif",
            "fontSizes": {
                "small": 12,
                "default": 14,
                "medium": 14,
                "large": 18,
                "extraLarge": 24
            },
            "fontWeights": {
                "lighter": 200,
                "default": 400,
                "bolder": 600
            }
        },
        "monospace": {
            "fontFamily": "'Courier New', Courier, monospace",
            "fontSizes": {
                "small": 12,
                "default": 14,
                "medium": 14,
                "large": 18,
                "extraLarge": 24
            },
            "fontWeights": {
                "lighter": 200,
                "default": 400,
                "bolder": 600
            }
        }
    },
    "textStyles": {
        "heading": {
            "fontType": "default",
            "size": "large",
            "weight": "bolder",
            "color": "default",
            "isSubtle": false
        }
    },
    "textBlock": {
        "headingLevel": 2
    },
    "imageSizes": {
        "small": 32,
        "medium": 52,
        "large": 100
    },
    "containerStyles": {
        "default": {
            "foregroundColors": {
                "default": {
                    "default": "#ffffff",
                    "subtle": "#adadad"
                },
                "dark": {
                    "default": "#ff201f1f",
                    "subtle": "#ff2d2c2c"
                },
                "light": {
                    "default": "#ffffffff",
                    "subtle": "#bfffffff"
                },
                "accent": {
                    "default": "#7f85f5",
                    "subtle": "#7f85f5"
                },
                "good": {
                    "default": "#ff92c353",
                    "subtle": "#e592c353"
                },
                "warning": {
                    "default": "#fff8d22a",
                    "subtle": "#e5f8d22a"
                },
                "attention": {
                    "default": "#ffd74654",
                    "subtle": "#e5d74654"
                }
            },
            "borderColor": "#CCCCCC",
            "backgroundColor": "#333333"
        },
        "emphasis": {
            "foregroundColors": {
                "default": {
                    "default": "#ffffff",
                    "subtle": "#adadad"
                },
                "dark": {
                    "default": "#ff201f1f",
                    "subtle": "#ff2d2c2c"
                },
                "light": {
                    "default": "#ffffffff",
                    "subtle": "#bfffffff"
                },
                "accent": {
                    "default": "#7f85f5",
                    "subtle": "#7f85f5"
                },
                "good": {
                    "default": "#ff92c353",
                    "subtle": "#e592c353"
                },
                "warning": {
                    "default": "#fff8d22a",
                    "subtle": "#e5f8d22a"
                },
                "attention": {
                    "default": "#ffd74654",
                    "subtle": "#e5d74654"
                }
            },
            "borderColor": "#666666",
            "backgroundColor": "#1f1f1f"
        },
        "accent": {
            "borderColor": "#62A8F7",
            "backgroundColor": "#C7DEF9",
            "foregroundColors": {
                "default": {
                    "default": "#ffffff",
                    "subtle": "#adadad"
                },
                "dark": {
                    "default": "#ff201f1f",
                    "subtle": "#ff2d2c2c"
                },
                "light": {
                    "default": "#ffffffff",
                    "subtle": "#bfffffff"
                },
                "accent": {
                    "default": "#7f85f5",
                    "subtle": "#7f85f5"
                },
                "good": {
                    "default": "#ff92c353",
                    "subtle": "#e592c353"
                },
                "warning": {
                    "default": "#fff8d22a",
                    "subtle": "#e5f8d22a"
                },
                "attention": {
                    "default": "#ffd74654",
                    "subtle": "#e5d74654"
                }
            }
        },
        "good": {
            "borderColor": "#69E569",
            "backgroundColor": "#CCFFCC",
            "foregroundColors": {
                "default": {
                    "default": "#ffffff",
                    "subtle": "#adadad"
                },
                "dark": {
                    "default": "#ff201f1f",
                    "subtle": "#ff2d2c2c"
                },
                "light": {
                    "default": "#ffffffff",
                    "subtle": "#bfffffff"
                },
                "accent": {
                    "default": "#7f85f5",
                    "subtle": "#7f85f5"
                },
                "good": {
                    "default": "#ff92c353",
                    "subtle": "#e592c353"
                },
                "warning": {
                    "default": "#fff8d22a",
                    "subtle": "#e5f8d22a"
                },
                "attention": {
                    "default": "#ffd74654",
                    "subtle": "#e5d74654"
                }
            }
        },
        "attention": {
            "borderColor": "#FF764C",
            "backgroundColor": "#FFC5B2",
            "foregroundColors": {
                "default": {
                    "default": "#ffffff",
                    "subtle": "#adadad"
                },
                "dark": {
                    "default": "#ff201f1f",
                    "subtle": "#ff2d2c2c"
                },
                "light": {
                    "default": "#ffffffff",
                    "subtle": "#bfffffff"
                },
                "accent": {
                    "default": "#7f85f5",
                    "subtle": "#7f85f5"
                },
                "good": {
                    "default": "#ff92c353",
                    "subtle": "#e592c353"
                },
                "warning": {
                    "default": "#fff8d22a",
                    "subtle": "#e5f8d22a"
                },
                "attention": {
                    "default": "#ffd74654",
                    "subtle": "#e5d74654"
                }
            }
        },
        "warning": {
            "borderColor": "#FFBC51",
            "backgroundColor": "#FFE2B2",
            "foregroundColors": {
                "default": {
                    "default": "#ffffff",
                    "subtle": "#adadad"
                },
                "dark": {
                    "default": "#ff201f1f",
                    "subtle": "#ff2d2c2c"
                },
                "light": {
                    "default": "#ffffffff",
                    "subtle": "#bfffffff"
                },
                "accent": {
                    "default": "#7f85f5",
                    "subtle": "#7f85f5"
                },
                "good": {
                    "default": "#ff92c353",
                    "subtle": "#e592c353"
                },
                "warning": {
                    "default": "#fff8d22a",
                    "subtle": "#e5f8d22a"
                },
                "attention": {
                    "default": "#ffd74654",
                    "subtle": "#e5d74654"
                }
            }
        }
    },
    "actions": {
        "maxActions": 6,
        "spacing": "Default",
        "buttonSpacing": 8,
        "showCard": {
            "actionMode": "Inline",
            "inlineTopMargin": 16,
            "style": "emphasis"
        },
        "preExpandSingleShowCardAction": false,
        "actionsOrientation": "Horizontal",
        "actionAlignment": "Left"
    },
    "adaptiveCard": {
        "allowCustomStyle": false
    },
    "imageSet": {
        "imageSize": "Medium",
        "maxImageHeight": 100
    },
    "factSet": {
        "title": {
            "size": "Default",
            "color": "Default",
            "isSubtle": false,
            "weight": "Bolder",
            "warp": true
        },
        "value": {
            "size": "Default",
            "color": "Default",
            "isSubtle": false,
            "weight": "Default",
            "warp": true
        },
        "spacing": 16
    },
    "lineHeights": {
        "small": 16,
        "default": 20,
        "medium": 20,
        "large": 24,
        "extraLarge": 32
    }
}
